export const GET_ACCUMULATED_ORDER_AMOUNT_SETTING = 'GET_ACCUMULATED_ORDER_AMOUNT_SETTING';
